import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Subscribe from "@/pages/Subscribe";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ExtensionPrivacy from "@/pages/ExtensionPrivacy";
import Terms from "@/pages/Terms";
import Landing from "@/pages/Landing";
import PaymentResult from "@/pages/PaymentResult";
import Dashboard from "@/pages/Dashboard";
import StaffLogin from "@/pages/StaffLogin";
import StaffHome from "@/pages/StaffHome";
import StaffConsole from "@/pages/StaffConsole";
import SubscriptionWall from "@/components/SubscriptionWall";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <div className="w-10 h-10 border-4 border-emerald-900 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  if (user.role !== "admin") {
    // الحساب المنتهي يدخل المنصة وتُقفل تبويباته داخلياً بشاشة تجديد (ExpiredGate)
    if (user.plan_status !== "active" && user.plan_status !== "expired" &&
        !(user.subscription_end && new Date(user.subscription_end) < new Date()))
      return <SubscriptionWall reason="pending" user={user} />;
  }
  return children;
};

const HomeRoute = () => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <div className="w-10 h-10 border-4 border-emerald-900 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  if (user) return <Navigate to="/dashboard" replace />;
  return <Landing />;
};

function App() {
  return (
    <div dir="rtl" lang="ar" className="min-h-screen">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/subscribe" element={<Subscribe />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/privacy" element={<ExtensionPrivacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/payment/result" element={<PaymentResult />} />
            <Route path="/staff" element={<StaffLogin />} />
            <Route path="/staff/home" element={<StaffHome />} />
            <Route path="/staff/console" element={<StaffConsole />} />
            <Route path="/" element={<HomeRoute />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
